module.exports = __webpack_public_path__ + "media/images/emblems/Lindau-blazon-206b2107a8d0bfc2d5ee766dddf67dc6.svg";